import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { withSize } from 'react-sizeme';
import { feature } from 'topojson-client';
import * as d3Geo from 'd3-geo';
import * as topojson from 'topojson-client';
import { connect } from 'unistore/react';

import { getMapColorColor, getDefaultColor } from '../../config';
import { startYearSelector } from '../../Selectors';

import './Maps.styl';

const d3 = {
  ...d3Geo
};

function mergeTopojsonByKey(topoJsonData, propertyKey) {
  const key = Object.keys(topoJsonData.objects)[0];
  const topoJsonObject = topoJsonData.objects[key];
  const groups = topoJsonObject.geometries
    .reduce((res, item) => {
      const currentValue = item.properties[propertyKey];

      if (!res.includes(currentValue)) {
        res.push(currentValue);
      }

      return res;
    }, [])
    .map(value =>
      topojson.merge(
        topoJsonData,
        topoJsonObject.geometries.filter(d => d.properties[propertyKey] === value)
      )
    );

  return groups;
}

class StaticMap extends PureComponent {
  render() {
    const {
      size, data, currentYear, labels = [],
      isBeforeElection, overlayDissolveKey, noColorIds = [],
      strokeWidth = 0.5
    } = this.props;

    if (!data) {
      return <div />
    }

    const isInactive = isBeforeElection && currentYear === 2019
    const { width } = size;
    const height = width * 1.25;
    const topoKey = Object.keys(data.objects)[0];
    const geojson = feature(data, data.objects[topoKey]);
    const geojsonVisible = { ...geojson, features : geojson.features.filter(feat => !noColorIds.includes(feat.properties.ISO3_CODE)) };
    const projection = d3.geoMercator().fitSize([width, height], noColorIds.length ? geojsonVisible : geojson);
    const geoPath = d3.geoPath().projection(projection);
    const colorizer = isInactive ? getDefaultColor : getMapColorColor;
    const overlayGeojson = overlayDissolveKey ? mergeTopojsonByKey(data, overlayDissolveKey) : null;
    const mapClasses = classnames('static-map', { 'is-inactive' : isInactive });

    return (
      <div className={mapClasses}>
        <svg className="static-map-svg" width={width} height={height}>
          <g className="map-layer-geometries">
          {geojson.features.map((feat, i) => {
            const hasColor = !noColorIds.includes(feat.properties.ISO3_CODE);
            return (
              <path
                key={`feature__${i}`}
                d={geoPath(feat)}
                fill={hasColor ? colorizer(feat.properties[currentYear]) : '#F9F9F9'}
                fillOpacity={0.9}
                stroke={hasColor ? colorizer(feat.properties[currentYear]) : '#dddddd'}
                strokeWidth={strokeWidth}
              />
            );
          })}
          </g>
          {overlayDissolveKey && (
            <g className="map-layer-geometries overlay">
              {overlayGeojson.map((feat, i) => (
                <path
                  key={`feature__${i}`}
                  d={geoPath(feat)}
                  fill="transparent"
                  stroke="#fff"
                  strokeWidth={strokeWidth}
                />
              ))}
            </g>
          )}
        </svg>
        {labels.map(label => {
          const pos = projection([label[2], label[1]]);
          return <div
            style={{
              top: `${~~pos[1]}px`,
              left: `${~~pos[0]}px`
            }}
            key={label[0]}
            className="map-label"
          >{label[0]}</div>;
        })}
      </div>
    );
  }
}

export default withSize()(
  connect(state => ({
    currentYear: startYearSelector(state),
    isBeforeElection: state.isBeforeElection
  }))(StaticMap)
);
